import moment from 'moment';
import Vue from 'vue';
import Component from 'vue-class-component';
import PeriodState from './PeriodConfig/PeriodState';
import IContext from '@/interfaces/StateMachine/IContext';
import { InjectReactive, Prop, PropSync } from 'vue-property-decorator';
import Dictionary from '@/types/Dictionary';

/** Classe utilitaire pour les périodes dans Config */
@Component
export default class PeriodConfig extends Vue implements IContext<PeriodState> {
    /** Récupération de la configuration */
    @PropSync('Configs', { default : () => {}})
    public configs !: Dictionary<any>; 

    /** Liste des erreurs liées à la configuration de la fonction */
    @PropSync('Errors', { default: () => [] })
    public errorList!: { Message: string }[];

    /** Variant de couleur à appliquer sur le composant */
    @Prop({ default: () => "secondary"})
    public Variant !: string;

//#region Machine à état
	/** Instance d'état */
	protected state: PeriodState = {} as PeriodState;

	/** Changement d'état */
	public TransitionTo(state: PeriodState, args: any = undefined): void {
		console.debug(`PeriodConfig - Context: Transition to ${(<any>state).constructor.name}.`);
		
		this.state = state;
		this.state.SetContext(this);
		
		/** Passage dans l'entrée de l'état */
		this.state.Enter(args);
	}

	/** 
	 * Sur entrée dans l'état
	 * @param args Arguments optionnels
	 **/
	public GoEnter(args: any): void {
		console.debug("PeriodConfig - GoEnter(args: %O)");

		this.state.Enter(args);
	}

	/** 
	 * Sur sortie de l'état pour retourner à l'étape précédente
	 * @param args Arguments optionnels
	 **/
	public GoLeave(args?: any): void {
		console.debug("PeriodConfig - GoLeaveBack(args: %O)");

		this.state.Leave(args);
	}
//#endregion Machine à état

//#region Variables des périodes

    /** Liste des périodes disponibles pour le MultiPeriod */
    protected availablePeriods : string[] = [];

    /** Liste des périodes disponibles pour le MultiPeriod */
    public get AvailablePeriods(): string[] {
        return this.availablePeriods;
    }
    /** Liste des périodes disponibles pour le MultiPeriod */
    public set AvailablePeriods(value: string[]) {
        this.availablePeriods = value;
    }
    
//#region MODE SIMPLE

    /** Liste des periodes du mode simple */
    protected simplePeriods: { Id: string, Label: string, Extras: Dictionary<any> }[] = [
        //{ Id: 'year_ip', Label: 'En cours', Extras: { Period: { Mode: "Simple", Type: "Sliding", Duration: 1, TimeUnit: "Year", Periodicity: "Month" } } },
        { Id: 'Year_5', Label: this.$t('LastYears5').toString() /* '5 dernières années' */, Extras: { Period: { Mode: "Simple", Type: "Sliding", Duration: 5, TimeUnit: "Year", Periodicity: "Year", Compare: false } } },
        { Id: 'Year_3', Label: this.$t('LastYears3').toString() /* '3 dernières années' */,  Extras: { Period: { Mode: "Simple", Type: "Sliding", Duration: 3, TimeUnit: "Year", Periodicity: "Year", Compare: false } } },
        { Id: 'Year_2', Label: this.$t('LastYears2').toString()/* '2 dernières années' */, Extras: { Period: { Mode: "Simple", Type: "Sliding", Duration: 2, TimeUnit: "Year", Periodicity: "Year", Compare: false } } },
        { Id: 'Month_36', Label: this.$t('LastMonths36').toString() /* '36 derniers mois' */, Extras: { Period: { Mode: "Simple", Type: "Sliding", Duration: 36, TimeUnit: "Month", Periodicity: "Month", Compare: false } } },
        { Id: 'Month_24', Label: this.$t('LastMonths24').toString() /* '24 derniers mois' */, Extras: { Period: { Mode: "Simple", Type: "Sliding", Duration: 24, TimeUnit: "Month", Periodicity: "Month", Compare: false } } },
        { Id: 'Month_12', Label: this.$t('LastMonths12').toString() /* '12 derniers mois' */, Extras: { Period: { Mode: "Simple", Type: "Sliding", Duration: 12, TimeUnit: "Month", Periodicity: "Month", Compare: false } } },
        { Id: 'Month_ip', Label: this.$t('CurrentYear').toString() /* 'Année en cours' */ , Extras: { Period: { Mode: "Simple", Type: "Sliding", Duration: 1, TimeUnit: "Year", Periodicity: "Month", Compare: false }}},
        { Id: 'Week_3', Label: this.$t('LastWeeks3').toString() /* '3 dernières semaines' */, Extras: { Period: { Mode: "Simple", Type: "Sliding", Duration: 3, TimeUnit: "Week", Periodicity: "Week", Compare: false }}},
        { Id: 'Week_2', Label: this.$t('LastWeeks2').toString() /* '2 dernières semaines' */, Extras: { Period: { Mode: "Simple", Type: "Sliding", Duration: 2, TimeUnit: "Week", Periodicity: "Week", Compare: false }}},
        { Id: 'Week_1', Label: this.$t('CurrentWeek').toString() /* 'Semaine en cours' */, Extras: { Period: { Mode: "Simple", Type: "Sliding", Duration: 1, TimeUnit: "Week", Periodicity: "Week", Compare: false } } },
        { Id: 'Day_21', Label: this.$t('LastDays21').toString() /* '21 derniers jours' */, Extras: { Period: { Mode: "Simple", Type: "Sliding", Duration: 21, TimeUnit: "Day", Periodicity: "Day", Compare: false } } },
        { Id: 'Day_14', Label: this.$t('LastDays14').toString()/* '14 derniers jours' */ , Extras: { Period: { Mode: "Simple", Type: "Sliding", Duration: 14, TimeUnit: "Day", Periodicity: "Day", Compare: false } } },
        { Id: 'Day_7', Label: this.$t('LastDays7').toString() /* '7 derniers jours' */ , Extras: { Period: { Mode: "Simple", Type: "Sliding", Duration: 7, TimeUnit: "Day", Periodicity: "Day", Compare: false } } },
        { Id: 'Day_ip', Label: this.$t('CurrentMonth').toString()/* 'Mois en cours' */ , Extras: { Period: { Mode: "Simple", Type: "Sliding", Duration: 1, TimeUnit: "Month", Periodicity: "Day", Compare: false }}}
    ]

    /** Liste des periodes du mode simple */
    public get SimplePeriods(): { Id: string, Label: string, Extras: Dictionary<any> }[] {
        return this.simplePeriods;
    }

    /** Liste des periodes du mode simple */
    public set SimplePeriods(value: { Id: string, Label: string, Extras: Dictionary<any> }[]) {
        this.simplePeriods = value;
    } 

    /** Application de la périodicity par défaut */
    public SetDefaultPeriodicity(value: string){
        this.simplePeriods.map(p => {
            p.Extras.Period.Periodicity = value;
        })
    }

    /** Nom du type de période simple sélectionné (Année, Mois ou Jour) (Uniquement pour singlePeriod) */
    protected simplePeriodType: string = "";

    /** Retourne le type de period sélectionné */
    public get SimplePeriodType(): string {
        return this.simplePeriodType;
    }

    /** Applique le type de période */
    public set SimplePeriodType(value: string) {
        this.simplePeriodType = value
    }

    /** Nom du type d'unité de temps simple sélectionné (Année, Mois ou Jour) (Uniquement pour singlePeriod) */
    protected simplePeriodTimeUnit: string = "";

    /** Retourne l'unité de temps de la periode sélectionnée */
    public get SimplePeriodTimeUnit(): string {
        return this.simplePeriodTimeUnit;
    }

    /** Applique le type de période */
    public set SimplePeriodTimeUnit(value: string) {
        this.simplePeriodTimeUnit = value
    }

    /** Boolean pour l'affichage des modes de paramétrage */
    /** Affichage mode simple */
    protected hasSimpleMode: boolean = false;

    /** Affichage mode simple */
    public get HasSimpleMode(): boolean {
        return this.hasSimpleMode;
    }

    /** Affichage mode simple */
    public set HasSimpleMode(value: boolean) {
        this.hasSimpleMode = value;
    }

    /** Boolean pour l'affichage des périodicités mode Simple */
    /** Affichage de la liste des périodes avec périodicité */
    protected hasPeriodWithPeriodicity: boolean = false;
    /** Affichage périodicité année mode simple */
    protected hasSimpleYearPeriodicity: boolean = false;
    /** Affichage périodicité mois mode simple */
    protected hasSimpleMonthPeriodicity: boolean = false;
    /** Affichage périodicité semaine mode simple */
    protected hasSimpleWeekPeriodicity: boolean = false;
    /** Affichage périodicité jour mode simple */
    protected hasSimpleDayPeriodicity: boolean = false;
    /** Affichage périodicité heure mode simple */
    protected hasSimpleHourPeriodicity: boolean = false;
    /** Affichage périodicité 30 minutes mode simple */
    protected hasSimpleThirtyMinutesPeriodicity: boolean = false;
    /** Affichage périodicité 10 minutes mode simple */
    protected hasSimpleTenMinutesPeriodicity: boolean = false;
    
    /** Affichage de la liste des périodes sans périodicité */
    /** Affichage unité de temps année mode simple */
    protected hasSimpleYearTimeUnit: boolean = false;
    /** Affichage unité de temps mois mode simple */
    protected hasSimpleMonthTimeUnit: boolean = false;
    /** Affichage unité de temps semaine mode simple */
    protected hasSimpleWeekTimeUnit: boolean = false;
    /** Affichage unité de temps jour mode simple */
    protected hasSimpleDayTimeUnit: boolean = false;

    /** Boolean pour l'affichage de l'entrée manuelle de durée */
    /** Affichage d'input d'entrée manuelle de durée */
    protected hasManualEntryDuration: boolean = true;
    /** Spécificité benchmarking @Todo Voir avec S.LAVINA si vraiment utile ??? */
    protected hasLastYear: boolean = true;
    /** Pour l'affichage de l'input pour la sélection d'une année de référence */
    protected hasRefPeriod: boolean = true;


    /** Affichage de la liste des périodes avec périodicité */
    public get HasPeriodWithPeriodicity(): boolean {
        return this.hasPeriodWithPeriodicity;
    }
    /** Affichage de la liste des périodes avec périodicité */
    public set HasPeriodWithPeriodicity(value: boolean) {
        this.hasPeriodWithPeriodicity = value;
    }

    /** Affichage périodicité année mode simple */
    public get HasSimpleYearPeriodicity(): boolean {
        return this.hasSimpleYearPeriodicity;
    }
    /** Affichage périodicité année mode simple */
    public set HasSimpleYearPeriodicity(value: boolean) {
        this.hasSimpleYearPeriodicity = value;
    }

    /** Affichage périodicité mois mode simple */
    public get HasSimpleMonthPeriodicity(): boolean {
        return this.hasSimpleMonthPeriodicity;
    }
    /** Affichage périodicité mois mode simple */
    public set HasSimpleMonthPeriodicity(value: boolean) {
        this.hasSimpleMonthPeriodicity = value;
    }

    /** Affichage périodicité semaine mode simple */
    public get HasSimpleWeekPeriodicity(): boolean {
        return this.hasSimpleWeekPeriodicity;
    }
    /** Affichage périodicité semaine mode simple */
    public set HasSimpleWeekPeriodicity(value: boolean) {
        this.hasSimpleWeekPeriodicity = value;
    }

    /** Affichage périodicité jour mode simple */
    public get HasSimpleDayPeriodicity(): boolean {
        return this.hasSimpleDayPeriodicity;
    }
    /** Affichage périodicité jour mode simple */
    public set HasSimpleDayPeriodicity(value: boolean) {
        this.hasSimpleDayPeriodicity = value;
    }

    /** Affichage périodicité heure mode simple */
    public get HasSimpleHourPeriodicity(): boolean {
        return this.hasSimpleHourPeriodicity;
    }
    /** Affichage périodicité heure mode simple */
    public set HasSimpleHourPeriodicity(value: boolean) {
        this.hasSimpleHourPeriodicity = value;
    }

    /** Affichage périodicité 30 minutes mode simple */
    public get HasSimpleThirtyMinutePeriodicity(): boolean {
        return this.hasSimpleThirtyMinutesPeriodicity;
    }
    /** Affichage périodicité 30 minutes mode simple */
    public set HasSimpleThirtyMinutePeriodicity(value: boolean) {
        this.hasSimpleThirtyMinutesPeriodicity = value;
    }

    /** Affichage périodicité 10 minutes mode simple */
    public get HasSimpleTenMinutePeriodicity(): boolean {
        return this.hasSimpleTenMinutesPeriodicity;
    }
    /** Affichage périodicité 10 minutes mode simple */
    public set HasSimpleTenMinutePeriodicity(value: boolean) {
        this.hasSimpleTenMinutesPeriodicity = value;
    }
    
    /** Affichage des périodes sans périodicité */
    /** Affichage unité de temps année */
    public get HasSimpleYearTimeUnit(): boolean {
        return this.hasSimpleYearTimeUnit;
    }
    
    /** Affichage unité de temps année */
    public set HasSimpleYearTimeUnit(value: boolean) {
        this.hasSimpleYearTimeUnit = value;
    }

    /** Affichage unité de temps mois */
    public get HasSimpleMonthTimeUnit(): boolean {
        return this.hasSimpleMonthTimeUnit;
    }
    
    /** Affichage unité de temps mois */
    public set HasSimpleMonthTimeUnit(value: boolean) {
        this.hasSimpleMonthTimeUnit = value;
    }

    /** Affichage unité de temps semaine */
    public get HasSimpleWeekTimeUnit(): boolean {
        return this.hasSimpleWeekTimeUnit;
    }
    
    /** Affichage unité de temps semaine */
    public set HasSimpleWeekTimeUnit(value: boolean) {
        this.hasSimpleWeekTimeUnit = value;
    }

    /** Affichage unité de temps jour */
    public get HasSimpleDayTimeUnit(): boolean {
        return this.hasSimpleDayTimeUnit;
    }
    
    /** Affichage unité de temps jour */
    public set HasSimpleDayTimeUnit(value: boolean) {
        this.hasSimpleDayTimeUnit = value;
    }
    
    /** Affichage d'input d'entrée manuelle de durée */
    public get HasManualEntryDuration(): boolean {
        return this.hasManualEntryDuration;
    }
    /** Affichage d'input d'entrée manuelle de durée */
    public set HasManualEntryDuration(value: boolean) {
        this.hasManualEntryDuration = value;
    }

    /** Spécificité benchmarking @Todo Voir avec S.LAVINA si vraiment utile ??? */
    public get HasLastYear(): boolean {
        return this.hasLastYear;
    }
    /** Spécificité benchmarking @Todo Voir avec S.LAVINA si vraiment utile ??? */
    public set HasLastYear(value: boolean) {
        this.hasLastYear = value;
    }

    /** Pour l'affichage de l'input pour la sélection d'une année de référence */
    public get HasRefPeriod(): boolean {
        return this.hasRefPeriod;
    }
    /** Pour l'affichage de l'input pour la sélection d'une année de référence */
    public set HasRefPeriod(value: boolean) {
        this.hasRefPeriod = value;
    }

    /** 
     * @TODO FAIRE UNE LISTE DE PERIODES POUR LES PERIODICITES SEMAINE
     */
//#endregion MODE SIMPLE
//#region MODE AVANCE
    /** Affichage mode avancé */
    protected hasAdvancedMode: boolean = false;
    /** Boolean pour l'affichage des périodicités mode Avancée*/
    /** Affichage périodicité année mode avancée */
    protected hasAdvancedYearPeriodicity: boolean = false;
    /** Affichage périodicité mois mode avancée */
    protected hasAdvancedMonthPeriodicity: boolean = false;
    /** Affichage périodicité périodique mode avancée */
    protected hasAdvancedPeriodicPeriodicity: boolean = true; 
    /** Affichage périodicité semaine mode avancée */
    protected hasAdvancedWeekPeriodicity: boolean = true;
    /** Affichage périodicité jour mode avancée */
    protected hasAdvancedDayPeriodicity: boolean = false;
    /** Affichage périodicité heure mode avancée */
    protected hasAdvancedHourlyPeriodicity: boolean = false;
    /** Affichage périodicité 30 minutes mode avancée */
    protected hasAdvancedThirtyMinutePeriodicity: boolean = false;
    /** Affichage périodicité 10 minutes mode avancée */
    protected hasAdvancedTenMinutePeriodicity: boolean = false;
    /** Boolean pour l'affichage des types de période */
    /** Affichage du bloc des types de période */
    protected hasPeriodTypes: boolean = false;
    /** Boolean pour chaque type de période */
    /** Période glissante */
    protected hasSlidingPeriod: boolean = true;
    /** Période intervalle */
    protected hasRangedPeriod: boolean = false;
    /** Période date à date */
    protected hasDateToDatePeriod: boolean = false;
    /** Boolean pour créer une comparaison entre les périodes @Todo A mettre dans SinglePeriod et non dans le mode simple/avancée */
    protected hasCompare: boolean = false;
    /** Nombre d'éléments par défaut dans la liste des périodes avancées  */
    protected advancedPeriodsDefaultLength : number = 3;
    /** Possède une liste de sélection de périodicité */
    protected hasAdvancedPeriodicity: boolean = false;

    /** Affichage mode avancé */
    public get HasAdvancedMode(): boolean {
        return this.hasAdvancedMode;
    }
    /** Affichage mode avancé */
    public set HasAdvancedMode(value: boolean) {
        this.hasAdvancedMode = value;
    }

    /** Affichage périodicité année mode avancée */
    public get HasAdvancedYearPeriodicity(): boolean {
        return this.hasAdvancedYearPeriodicity;
    }
    /** Affichage périodicité année mode avancée */
    public set HasAdvancedYearPeriodicity(value: boolean) {
        this.hasAdvancedYearPeriodicity = value;
    }

    /** Affichage périodicité mois mode avancée */
    public get HasAdvancedMonthPeriodicity(): boolean {
        return this.hasAdvancedMonthPeriodicity;
    }
    /** Affichage périodicité mois mode avancée */
    public set HasAdvancedMonthPeriodicity(value: boolean) {
        this.hasAdvancedMonthPeriodicity = value;
    }

    /** Affichage périodicité périodique mode avancée */
    public get HasAdvancedPeriodicPeriodicity(): boolean {
        return this.hasAdvancedPeriodicPeriodicity;
    }
    /** Affichage périodicité périodique mode avancée */
    public set HasAdvancedPeriodicPeriodicity(value: boolean) {
        this.hasAdvancedPeriodicPeriodicity = value;
    }

    /** Affichage périodicité semaine mode avancée */
    public get HasAdvancedWeekPeriodicity(): boolean {
        return this.hasAdvancedWeekPeriodicity;
    }
    /** Affichage périodicité semaine mode avancée */
    public set HasAdvancedWeekPeriodicity(value: boolean) {
        this.hasAdvancedWeekPeriodicity = value;
    }

    /** Affichage périodicité jour mode avancée */
    public get HasAdvancedDayPeriodicity(): boolean {
        return this.hasAdvancedDayPeriodicity;
    }
    /** Affichage périodicité jour mode avancée */
    public set HasAdvancedDayPeriodicity(value: boolean) {
        this.hasAdvancedDayPeriodicity = value;
    }

    /** Affichage périodicité heure mode avancée */
    public get HasAdvancedHourlyPeriodicity(): boolean {
        return this.hasAdvancedHourlyPeriodicity;
    }
    /** Affichage périodicité heure mode avancée */
    public set HasAdvancedHourlyPeriodicity(value: boolean) {
        this.hasAdvancedHourlyPeriodicity = value;
    }

    /** Affichage périodicité 30 minutes mode avancée */
    public get HasAdvancedThirtyMinutePeriodicity(): boolean {
        return this.hasAdvancedThirtyMinutePeriodicity;
    }
    /** Affichage périodicité 30 minutes mode avancée */
    public set HasAdvancedThirtyMinutePeriodicity(value: boolean) {
        this.hasAdvancedThirtyMinutePeriodicity = value;
    }

    /** Affichage périodicité 10 minutes mode avancée */
    public get HasAdvancedTenMinutePeriodicity(): boolean {
        return this.hasAdvancedTenMinutePeriodicity;
    }
    /** Affichage périodicité 10 minutes mode avancée */
    public set HasAdvancedTenMinutePeriodicity(value: boolean) {
        this.hasAdvancedTenMinutePeriodicity = value;
    }

    /** Affichage du bloc des types de période */
    public get HasPeriodTypes(): boolean {
        return this.hasPeriodTypes;
    }
    /** Affichage du bloc des types de période */
    public set HasPeriodTypes(value: boolean) {
        this.hasPeriodTypes = value;
    }

    /** Période glissante */
    public get HasSlidingPeriod(): boolean {
        return this.hasSlidingPeriod;
    }
    /** Période glissante */
    public set HasSlidingPeriod(value: boolean) {
        this.hasSlidingPeriod = value;
    }

    /** Période intervalle */
    public get HasRangedPeriod(): boolean {
        return this.hasRangedPeriod;
    }
    /** Période intervalle */
    public set HasRangedPeriod(value: boolean) {
        this.hasRangedPeriod = value;
    }

    /** Période date à date */
    public get HasDateToDatePeriod(): boolean {
        return this.hasDateToDatePeriod;
    }
    /** Période date à date */
    public set HasDateToDatePeriod(value: boolean) {
        this.hasDateToDatePeriod = value;
    }

    /** Boolean pour créer une comparaison entre les périodes @Todo A mettre dans SinglePeriod et non dans le mode simple/avancée */
    public get HasCompare(): boolean {
        return this.hasCompare;
    }
    /** Boolean pour créer une comparaison entre les périodes @Todo A mettre dans SinglePeriod et non dans le mode simple/avancée */
    public set HasCompare(value: boolean) {
        this.hasCompare = value;
    }

    /** Nombre d'éléments par défaut dans la liste des périodes avancées  */
    public get AdvancedPeriodsDefaultLength() : number {
        return this.advancedPeriodsDefaultLength;
    }

    /** Nombre d'éléments par défaut dans la liste des périodes avancées  */
    public set AdvancedPeriodsDefaultLength(value : number) {
        this.advancedPeriodsDefaultLength = value;
    }

    /** Possède une liste de sélection de périodicité */
    public get HasAdvancedPeriodicity(): boolean {
        return this.hasAdvancedPeriodicity;
    }
    /** Possède une liste de sélection de périodicité */
    public set HasAdvancedPeriodicity(value: boolean) {
        this.hasAdvancedPeriodicity = value;
    }

//#endregion MODE AVANCE

//#region TENDANCE
    /** Boolean pour l'affichage des types de tendances */
    /** Affichage du bloc des tendances */
    protected hasTrend: boolean = false;
    /** Affichage du bloc des tendances que en mode simple */
    protected hasTrendOnSimpleMode: boolean = false;
    /** Affichage du bloc des tendances que en mode avancé */
    protected hasTrendOnAdvancedMode: boolean = false;
    /** Boolean pour l'affichage de l'ensemble des tendance de Type Trend */
    protected hasTrendType: boolean = false;
    /** Boolean pour l'affichage du bouton de période consécutive */
    protected hasPreviousTrend: boolean = false;
    /** Boolean pour l'affichage du bouton de année - 1 */
    protected hasLastYearTrend: boolean = false;
    /** Boolean pour l'affichage du bouton d'année de référence */
    protected hasRefYearTrend: boolean = false;
    /** Boolean pour l'affichage de l'ensemble des tendance de Type Range */
    protected hasReferencePeriod: boolean = false;

    /** Affichage du bloc des tendances */
    public get HasTrend(): boolean {
        return this.hasTrend;
    }
    /** Affichage du bloc des tendances */
    public set HasTrend(value: boolean) {
        this.hasTrend = value;
    }

    /** Affichage du bloc des tendances que en mode simple */
    public get HasTrendOnSimpleMode(): boolean {
        return this.hasTrendOnSimpleMode;
    }
    /** Affichage du bloc des tendances que en mode simple */
    public set HasTrendOnSimpleMode(value: boolean) {
        this.hasTrendOnSimpleMode = value;
    }
    
    /** Affichage du bloc des tendances que en mode avancé */
    public get HasTrendOnAdvancedMode(): boolean {
        return this.hasTrendOnAdvancedMode;
    }
    /** Affichage du bloc des tendances que en mode avancé */
    public set HasTrendOnAdvancedMode(value: boolean) {
        this.hasTrendOnAdvancedMode = value;
    }

    /** Affichage du bloc des tendances de type Trend */
    public get HasTrendType(): boolean {
        return this.hasTrendType;
    }
    /** Affichage du bloc des tendances de type Trend */
    public set HasTrendType(value: boolean) {
        this.hasTrendType = value;
    }

    /** Boolean pour l'affichage du bouton de période consécutive */
    public get HasPreviousTrend(): boolean {
        return this.hasPreviousTrend;
    }
    /** Boolean pour l'affichage du bouton de période consécutive */
    public set HasPreviousTrend(value: boolean) {
        this.hasPreviousTrend = value;
    }

    /** Boolean pour l'affichage du bouton de année - 1 */
    public get HasLastYearTrend(): boolean {
        return this.hasLastYearTrend;
    }
    /** Boolean pour l'affichage du bouton de année - 1 */
    public set HasLastYearTrend(value: boolean) {
        this.hasLastYearTrend = value;
    }

    /** Affichage du bloc des tendances de type Range */
    public get HasRefYearTrend(): boolean {
        return this.hasRefYearTrend;
    }
    /** Affichage du bloc des tendances de type Range */
    public set HasRefYearTrend(value: boolean) {
        this.hasRefYearTrend = value;
    }
    
    /** Boolean pour l'affichage du bouton d'année de référence */
    public get HasReferencePeriod(): boolean {
        return this.hasReferencePeriod;
    }
    /** Boolean pour l'affichage du bouton d'année de référence */
    public set HasReferencePeriod(value: boolean) {
        this.hasReferencePeriod = value;
    }
    //#endregion TENDANCE
    //#endregion Variables des périodes

    /** Correspond au premier jour de la semaine dans les b-form-datepicker (0: dim., 1: lun., 6: sam.) */
    protected startWeekday : number = 1;

    /** Donne la liste des mois de l'année */
    protected getMonths() {
        console.debug("PeriodConfig - getMonths()");
        
        /** 
         * @todo Voir pour utiliser moment.months() qui liste les mois selon la localisation
         * @see https://momentjs.com/docs/#/i18n/listing-months-weekdays/
         */
        let months: { Id: string, Label: string }[] = [
            { Id: '01', Label: this.$t('MonthJanuary').toString() }, // 'Janvier'
            { Id: '02', Label: this.$t('MonthFebruary').toString() }, // 'Février'
            { Id: '03', Label: this.$t('MonthMarch').toString() }, // 'Mars'
            { Id: '04', Label: this.$t('MonthApril').toString() }, // 'Avril'
            { Id: '05', Label: this.$t('MonthMay').toString() }, // 'Mai'
            { Id: '06', Label: this.$t('MonthJune').toString() }, // 'Juin'
            { Id: '07', Label: this.$t('MonthJuly').toString() }, // 'Juillet'
            { Id: '08', Label: this.$t('MonthAugust').toString() }, // 'Août'
            { Id: '09', Label: this.$t('MonthSeptember').toString() }, // 'Septembre'
            { Id: '10', Label: this.$t('MonthOctober').toString() }, // 'Octobre'
            { Id: '11', Label: this.$t('MonthNovember').toString() }, // 'Novembre'
            { Id: '12', Label: this.$t('MonthDecember').toString() } // 'Décembre'
        ];

        return months;
    }

    /**
     * Donne la liste année décroissante par rapport au nombre d'années souhaitées
     * @param startYear Année de départ
     */
    protected getYears(startYear : number) {
        console.debug("PeriodConfig - getYears(%O) ", startYear);

        let years: { Id: number, Label: string }[] = [];

        // Année actuelle
        let year: number = new Date().getUTCFullYear();

        let nbYears: number = year - startYear;

        // boucle de création des éléments
        for (let index = 0; index <= nbYears; index++) {
            years.push({ Id: year - index, Label: (year - index).toString()})
        }

        console.debug("PeriodConfig - years", years);

        return years;
    }

    /**
     * Donne le nombre de semaines selon une année donnée
     * @param year année 
     * @returns Nombre de semaine de l'annee
     */
    protected getWeekNumber(year: number): number {
        return moment().year(year).weeksInYear();
    }

    /**
     * Formatte le texte renseigné en remplaçant les caractères non numériques
     * @param value texte à formatter
     * @returns texte formatté sans caractère non numériques
     */
    public onlyNumber(value): string {
        return value.replace(/[^0-9.]/g,'');
    }

    /** Nom du composant Work dont la machine à état spécifique est à charger éventuellement */
    @InjectReactive()
    public WorkType!: string;

    /** Initialisation de la machine à états des périodes pour obtenir les états spécifiques à une fonction Analysis et éventuellement à un composant Work */
    protected async initStateMachine(newVal, oldVal) {
        if ("Feature" in this.configs && this.configs["Feature"] && newVal != oldVal) {
            console.debug("PeriodConfig - initStateMachine() - featureName : %O - workName : %O", this.configs["Feature"], this.WorkType);

            let workStateType = undefined;
            let featureStateType = undefined;
            if (this.WorkType) {
                /** Si une déclinaison d'état spécifique existe pour le Work alors on le charge sinon on charge l'état associé à la fonction */
                workStateType = await import('@/components/commons/Config/Periods/PeriodConfig/' + this.configs["Feature"] + '/' + this.WorkType + 'State')
                    .catch(async error => {
                        console.debug("PeriodConfig - initStateMachine() - error.code : ", error.code);
                        /** Chargement du State de la feature si pas de state pour le Work existant
                         * @description On passe par un catch de l'exception car il n'est à priori pas possible de tester si un module existe ou non. Un peu pourri... 🤮 mais pas le choix. 😥 */
                        if (error.code == 'MODULE_NOT_FOUND') {
                            featureStateType = await import("@/components/commons/Config/Periods/PeriodConfig/" + this.configs["Feature"] + "State");
                            console.debug("PeriodConfig - initStateMachine() - stateType 1 : ", workStateType);
                        }
                    });
            }
            else
                featureStateType = await import("@/components/commons/Config/Periods/PeriodConfig/" + this.configs["Feature"] + "State");
                
            console.debug("PeriodConfig - initStateMachine() - stateType 2 - workStateType : %O - featureStateType : %O", workStateType, featureStateType);

            /** Instanciation dynamique de l'état */
            let stateInstance = undefined;
            if (workStateType)
                stateInstance = new workStateType.default();
            else
                stateInstance = new featureStateType.default();

            /** Instancie un nouveau contexte ou bien réalise une transition vers un autre type d'état si l'instance de contexte existe déjà */
            console.debug("PeriodConfig - initStateMachine() - workStateType : %O - featureStateType : %O - stateInstance : %O", workStateType, featureStateType, stateInstance);
            this.TransitionTo(stateInstance);
        }
    }
}